/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeatmapAnalysis = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M20.5 17.5v3h-3v-3zm0-14v3h-3v-3zm-3-1.5H16v6h6V2h-1.5zm0 14H16v6h6v-6h-1.5zM8 9H2v6h6zm0 7H2v6h6zm8-7h6v6h-6zM9 2h6v6H9V4zm4 2h-2v2h2zm2 5v6H9V9h4zm-2 4v-2h-2v2zm2 3v6H9v-6h4zm-2 4v-2h-2v2zM8 6v2H2V2h6v2zM6 4H4v2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeatmapAnalysis as HeatmapAnalysis };
